<script setup>
import {computed, ref} from "vue";
import useGrid from "@/composables/useGrid";
import marketsService from "@/services/markets.service";
import TablePager from "@/components/TablePager.vue";
import {getLogo} from "@/helpers/logo";
import {getNoun} from "../../helpers/string";

const props = defineProps(['filters']);
const {gridParams, gridMethods, items} = useGrid(getPartnershipsList, 7);

const objectType = ref('');
const objectId = ref(0);
const objectName = ref('');
const showModal = ref(false);

const title = computed(() => {
    if (objectType.value === 'focus_area') {
        return `Partnerships in "${objectName.value}" focus area`;
    } else {
        return `${objectName.value}'s Partnerships`;
    }
});

function getPartnershipsList(pageParams) {
    pageParams.filters = {
        ...props.filters,
        objectType: objectType.value,
        objectId: objectId.value
    };

    return marketsService.getPartnershipsIndex(pageParams);
}

function open({type, id, name}) {
    objectType.value = type;
    objectId.value = id;
    objectName.value = name;

    showModal.value = true;
    gridMethods.resetList();
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" :title="title" modal-class="modal-md modal-blue" :hide-footer="!items.length">
        <div v-if="gridParams.totalRowsCount" class="modal-blue__top">
            <b>{{gridParams.totalRowsCount}} {{getNoun('partnership', gridParams.totalRowsCount)}}</b>

            <a v-if="objectType === 'corporate'" :href="`/startups?client=${objectName}`" target="_blank" class="modal-blue__search"> Open in Search</a>
        </div>

        <ul class="list-partner">
            <li v-for="partnership in items" :key="partnership.id">
                <div class="list-partner__image">
                    <img :src="getLogo(partnership.startup_logo)" alt="Logo" width="60" height="60"/>
                </div>
                <div style="flex: 1">
                    <b>{{partnership.year}}</b>: {{partnership.summary[0]}}

                    <template v-if="partnership.summary.length > 1">
                        <a v-if="partnership.startup_id" :href="`/startups/${partnership.startup_id}`" target="_blank">{{partnership.startup_name}}</a>
                        <template v-else>
                            {{partnership.startup_name}}
                        </template>

                        {{partnership.summary[1]}}
                    </template>
                </div>
            </li>
        </ul>

        <template #modal-footer>
            <TablePager
                v-if="items.length"
                :pages-count="gridParams.pagesCount"
                :init-page="gridParams.currentPage"
                @changePage="gridMethods.changePage"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
